import React, { useState, useMemo } from 'react';
import './Services.css';

// 🖼️ Images
import visitor from "../src/Assets/visitor_new.png";
import neo from "../src/Assets/NEO_new2.png";
import policyack from "../src/Assets/PolicyAck_new.png";
// import servicebg1 from "../src/Assets/tree3.png";
import mdr from "../src/Assets/MDR.png";
import taa from "../src/Assets/TAA Hardware.png";
import cmmc from "../src/Assets/cmmc-mew.png";
import migration from "../src/Assets/migration.png";
import managed from "../src/Assets/managed.png";
import assessment from "../src/Assets/assessment1.png";
import gap from "../src/Assets/gap2.png";
import provsion from "../src/Assets/provsion enclave.png";
import azure from "../src/Assets/Azure-Gov.png";
import fusl from "../src/Assets/AOSG_New.png";
import grctool from "../src/Assets/GRC.png";
import policydoc from "../src/Assets/5.png";
import virtualcio from "../src/Assets/CIO.png";
import virtualciso from "../src/Assets/CISO1.png";
// import badge10 from "../src/Assets/10.png";
// import badge40 from "../src/Assets/40.png";
// import hat from "../src/Assets/hat.png";
// import snow from "../src/Assets/snow.png";

// 🧩 Services Data
const servicesData = [
  {
    title: 'CMMC Compliance Solutions',
    price: 'As per Scope',
    list: 'As per scope',
    logo: cmmc,
    offer_title: 'Holiday Offer',
    features: [
      'CMMC Compliance Roadmap',
      'Gap Analysis & Risk Assessment',
      'CMMC Certification Support',
      'Tailored Security Solutions',
      'Ongoing CMMC Maintenance'
    ]
  },
  {
    title: 'Managed Services',
    price: '$5,000.00',
    list: '$5,000.00',
    save: '10.00%',
    offer_title: 'Holiday Offer',
    logo: managed,
    features: [
      'Certified Microsoft MVPs & Ex-Microsoft Employees',
      'Efficient & Expert Resources',
      'Three Levels of Support Models',
      'Tailored to Customer IT Needs and Budget'
    ]
  },
  {
    title: 'Migration Services',
    price: '$120.00/user',
    offer_title: 'Holiday Offer',
    logo: migration,
    save: '10.00%',
    features: [
      'Comprehensive Cloud Migration',
      'Tailored Migration Plans',
      'Expert Support & Consultation',
      'Data Security & Compliance',
      'Post-Migration Optimization'
    ]
  },
  {
    title: 'Microsoft 365 GCCHigh Business Premium and other GCCHigh licenses',
    price: '$429.60',
    list: '',
    save: '10.00%',
    logo: fusl,
    offer_title: 'Holiday Offer',
    features: [
      'Expert Licensing Advice',
      'Licenses Provisioning Guidance',
      'Hosted in U.S. Sovereign Cloud',
      'Microsoft Approved AOSG partner',
      'Expert former Microsoft FTE and Microsoft MVPs'
    ]
  },
  {
    title: 'CMMC Policy Documentation',
    price: ' $9,000.00',
    save: '10.00%',
    logo: policydoc,
    offer_title: 'Holiday Offer',
    features: [
      'End to End CMMC Policy writing from our Templates',
      'Core Documents - SSP, Plan of Action, Share Responsibility, etc',
      'SharePoint Online based 10 Databases',
      '14 Policies Documents',
      '6 User Agreements ',
      '14 Procedure Documents'
    ]
  },
  {
    title: 'Azure Government Subscriptions',
    price: 'As per Scope',
    logo: azure,
    offer_title: 'Holiday Offer',
    features: [
      'Azure Governance Expertise',
      'Subscription Reseller',
      'Comprehensive Compliance and Security',
      'Cost Optimization',
      'Customized Solutions'
    ]
  },
  {
    title: 'Assessment Readiness Review',
    price: 'As per Scope',
    logo: assessment,
    offer_title: 'Holiday Offer',
    features: [
      'Conduct Pre-assessment Interviews',
      'Policies & Procedures Reviews',
      'Plan of Actions & Milestones Items (POA&Ms)',
      'Complete POA&M remediation tasks',
      'Remediate remaining items in preparation for assessment',
      'Conduct final review of non-compliance items',
      'Confirm readiness to proceed with assessment',
      'Identify Third Party Assessor',
      'Schedule Assessment Date(s)',
      'Facilitate Kick-off Meeting between Assessor and Client Team',
      'Follow-up on outstanding items after assessment completion'
    ]
  },
  {
    title: 'TAA-Compliant Hardware Reselling',
    price: 'As per Scope',
    logo: taa,
    offer_title: 'Holiday Offer',
    features: [
      'TAA Compliance Assurance',
      'Quality-Approved Products',
      'Custom Solutions',
      'Fast Delivery & Support',
      'Consultative Reselling'
    ]
  },
  {
    title: 'GRC Tool',
    price: '$2,500.00',
    list: 'To be discussed',
    save: '40.00%',
    offer_title: 'Holiday Offer',
    logo: grctool,
    features: [
      'Helps identify, assess, and reduce potential business or security risks.',
      'Ensures the organization follows all laws, standards, and regulations.',
      'Centralizes company policies for easy creation, updates, and employee access.',
      'Manages internal and external audits with tracking of findings and actions.',
      'Provides real-time insights through visual reports and analytics.'
    ]
  },
  {
    title: 'Visitor APP',
    price: '$2,000.00',
    list: '$2500.00',
    save: '40.00%',
    offer_title: 'Holiday Offer',
    logo: visitor,
    features: [
      'Quick Check-In: Visitors enter details and check in effortlessly.',
      'Integrated Camera: Capture photos for identification and security.',
      'Easy Secure Check-Out: Visitors log their departure with a single click.',
      'Digital Records: All visitor information is securely stored for easy access.',
      'User-Friendly Design: Simple and intuitive for hassle-free use.',
      'Emergency Search: In case of emergency, search the visitor in the building.'
    ]
  },
  {
    title: 'PolicyAck',
    price: '$500.00',
    // list: '$13,999.00',
    save: '40.00%',
    offer_title: 'Holiday Offer',
    logo: policyack,
    features: [
      'Helps Overcome Policy Management Challenges',
      'Primary Policy Repository',
      'Assign Policies to Groups or Users',
      'SharePoint Online Backend',
      'Deployed in Customer Tenant',
      'Live Compliance Dashboard',
      'Easy to Update/Append Policies',
      'Build & Customize Policy Online',
      'Completion Certificate & Tracking',
      'Defaulters Alerts & Actions',
      'Email Alerts & Reminders',
      'Serverless & Modern'
    ]
  },
  {
    title: 'NEO Identity MSP',
    price: '$1,500.00/Month + $75/Tenant',
    // list: '$14,999.00',
    save: '40.00%',
    offer_title: 'Holiday Offer',
    logo: neo,
    features: [
      'Multi-tenant architecture to manage multiple customer tenants',
      'Centralized automation engine for all client environments',
      'Automated user, group, and mailbox lifecycle management across tenants',
      'Scalable Azure Function App–based deployment',
      'Rapid tenant onboarding using ARM templates',
      'Designed specifically for Managed Service Providers (MSPs)',
      'Enables monetization of identity automation services',
      'Pricing scales with business growth (per-tenant model)'
    ]
  },
  {
    title: 'NEO Identity Hybrid',
    price: '$1,000.00/Month',
    // list: '$14,999.00',
    save: '40.00%',
    offer_title: 'Holiday Offer',
    logo: neo,
    features: [
      'Includes all features of NEO Identity Cloud',
      'Supports hybrid identity environments (On-Prem AD + Entra ID)',
      'Handles complex identity attributes and synchronization logic',
      'Advanced automation for hybrid mailbox conversions',
      'Ensures identity consistency between on-prem and cloud systems',
      'Secure hybrid connectivity using certificate-based authentication',
      'Designed for enterprise-level identity complexity'
    ]
  },
  {
    title: 'NEO Identity Cloud',
    price: '$700.00/Month',
    // list: '$14,999.00',
    save: '40.00%',
    offer_title: 'Holiday Offer',
    logo: neo,
    features: [
      'Automated user account creation using SharePoint lists',
      'Automatic group assignment in Microsoft Entra ID',
      'Automated user and shared mailbox provisioning',
      'SharePoint-to-Entra ID end-to-end automation',
      'Microsoft Graph API integration for mailbox type conversion',
      'Eliminates manual user and mailbox management',
      'Built for Microsoft 365 cloud-only environments',
      'Application Insights enabled for basic logging and monitoring'
    ]
  },
  {
    title: 'G5 MDR (Managed & Detection Response)',
    price: '$5,000.00',
    save: '10.00%',
    logo: mdr,
    offer_title: 'Holiday Offer',
    features: [
      '24/7 Monitoring',
      'Proactive Threat Detection',
      'Expert Response Teams',
      'MS Exchange-Specific Protection',
      'Compliance & Reporting'
    ]
  },
  {
    title: 'Gap Analysis',
    price: '$9,995.00',
    save: '10.00%',
    logo: gap,
    offer_title: 'Holiday Offer',
    features: [
      'Identify contract requirements for: CUI, FCI, Other regulations',
      'Review Network and Data Flow diagrams',
      'Define Security Boundary Scope',
      'Provide comprehensive report:',
      '- Identify non-compliance items',
      '- Recommend next steps for remediation'
    ]
  },
  {
    title: 'Provision Enclave',
    price: '$4,995.00',
    list: '$4,995.00',
    save: '10.00%',
    logo: provsion,
    offer_title: 'Holiday Offer',
    features: [
      'Assist with application for approval for M365 GCC High',
      'Provides a cloud infrastructure for sensitive information (Enclave)',
      'Deploy GCC High Tenant Azure Government Subscriptions',
      'Enable and configure Azure security compliance Tools',
      'Receive Golden Five end-to-end deployment support'
    ]
  },
  {
    title: 'Virtual CISO Service',
    price: '$250/hour',
    logo: virtualciso,
    save: '',
    features: [
      'Execute Cyber Security Assessment',
      'Provider Cyber Security Improvement',
      'Present Improvements to Board of Directors',
      'Guide IT Team on Implementing Improvement',
      'Guide regular Staff Cyber Trainings',
      'Submit GAP closure Report',
      'Quarterly Improvement Reviews'
    ]
  },
  {
    title: 'Virtual CIO Service',
    price: '$200/hour',
    logo: virtualcio,
    save: '',
    features: [
      'Execute IT Assessment',
      'Provider IT Improvement Report',
      'Present Improvements to Board of Directors',
      'Align Right Resources, Products, and Vendors',
      'Guide IT Team on Implementing Improvement',
      'Guide regular Staff Cyber Trainings',
      'Manage and Review Monthly Status',
      'Participate in any IT change and High Sev Incident'
    ]
  },
];

function Services() {
  const [selectedService, setSelectedService] = useState(null);
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return servicesData;
    return servicesData.filter(s => {
      const text = [s.title, s.price, s.list, (s.features || []).join(' ')].join(' ').toLowerCase();
      return text.includes(q);
    });
  }, [query]);

  const openModal = (service) => setSelectedService(service);
  const closeModal = () => setSelectedService(null);

  return (
    <div className="services-main">
      <img src='tree3.png' alt="Background" className="background-image" />

      <div className="services-content">
        <div className="services-header">
          <div className="title-wrapper">
            {/* Commented out holiday hat */}
            {/* <img src={hat} alt="Holiday Hat" className="hatimg" /> */}
            <h1 className="services-title">Products & Services</h1>
          </div>

          <p className="services-description">
            Discover our range of secure and scalable digital services tailored to meet your business needs.
          </p>

          {/* 🔍 Search Bar */}
          <div className="search-container">
            <input
              type="text"
              placeholder="Search products, services..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="search-input"
            />
          </div>
        </div>

        {/* 🔹 Services Grid */}
        <div className="services-container">
          {filtered.length === 0 ? (
            <div style={{ color: '#fff', padding: 40, gridColumn: '1/-1', textAlign: 'center' }}>
              <h3>No results found for "{query}"</h3>
              <p>Try searching with a different keyword.</p>
            </div>
          ) : (
            filtered.map((service, index) => {
              /* OFFER LOGIC COMMENTED OUT 
                const rawPriceStr = service.price || service.list || '';
                const numericPrice = parsePriceValue(rawPriceStr);
                ...etc
              */

              return (
                <div key={index} className="service-card">
                  {/* OFFER BADGE IMAGES COMMENTED OUT */}
                  {/* {isFifty ? (
                    <img src={badge40} alt="40% badge" className="offer-badge-img badge-50" />
                  ) : (
                    !isNoBadge ? (
                      <img src={badge10} alt="10% badge" className="offer-badge-img badge-10" />
                    ) : null
                  )} 
                  */}

                  <div className="service-logo-wrapper">
                    {service.logo ? (
                      <img src={service.logo} alt={`${service.title} Logo`} className="service-logo" />
                    ) : (
                      <div className="service-logo-placeholder" aria-hidden="true">{'\u00A0'}</div>
                    )}
                  </div>

                  {/* Offer label commented out */}
                  {/* <h2 className="offer-head">&nbsp;</h2> */}
                  
                  <h2 className="service-title">{service.title || '\u00A0'}</h2>

                  {/* Pricing: Showing actual price from data only */}
                  <div className="pricing-row">
                    <p className="service-price">
                      {service.price ? `Price: ${service.price}` : '\u00A0'}
                    </p>
                  </div>

                  {/* Save percentage commented out */}
                  {/* <p className="service-save">&nbsp;</p> */}

                  <button className="learn-more-btn" onClick={() => openModal(service)}>Learn More</button>
                  
                  {/* Holiday snow commented out */}
                  {/* <img src={snow} alt="Snow" className="snow-img" /> */}
                </div>
              );
            })
          )}
        </div>
      </div>

      {/* Modal Section */}
      {selectedService && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-btn" onClick={closeModal}>&times;</span>
            <h2>{selectedService.title}</h2>
            <div className="modal-pricing">
               <p className="service-price">Price: {selectedService.price || 'As per Scope'}</p>
            </div>
            <div>
              <strong className="blue-strong">Features:</strong>
              <ul>
                {selectedService.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
            </div>

            <button
              className="learn-more-btn"
              onClick={() => window.open('https://forms.office.com/r/t1uVCwKtMd', '_blank')}
              style={{ marginTop: '20px', marginLeft: 'auto', display: 'block' }}
            >
              Buy Now
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Services;